export interface FaqItem {
  q: string;
  a: string;
}

export const faqItems: FaqItem[] = [
  {
    q: '你们的"求证"具体是怎么做的？',
    a: '先完整记录网传说法原文，再拆出其中可以验证的关键事实点，然后分别去找一手信源、机构口径和独立旁证。多个独立来源指向同一结论时，才会给出"已求证"或"已辟谣"的判断，否则会明确标注"求证中"或"存疑"。',
  },
  {
    q: '"求证中"和"证据存疑"有什么区别？',
    a: '"求证中"表示材料还不够，结论未定，需要继续收集信源；"证据存疑"则更进一步，表示现有的关键材料本身存在拼接、断章取义或数据不一致的问题，已不足以支撑网传结论。',
  },
  {
    q: '为什么有些爆料你们不给明确结论？',
    a: '信息不足时给出确定结论，本身就是一种误导。我们更愿意承认"暂时无法判断"，把已经核实的部分和仍然空白的分开列出来，让读者自己掌握判断的依据。',
  },
  {
    q: '我可以提供线索或指出你们的疏漏吗？',
    a: '当然欢迎。你可以把原始链接、完整视频或截图发到我们的求证邮箱，注明获取时间和来源。如果我们的结论有误，也会在专题页顶部更新说明，并保留修改记录。',
  },
  {
    q: '你们会公布事件当事人的私人信息吗？',
    a: '不会。我们只讨论与公共议题相关的可核实信息，不公开未获授权的私人资料，也不鼓励对个人生活进行无根据的揣测。',
  },
];